import React from "react";
import "./App.css";
import Kiosk from "./components/kiosk";

export default function App() {
  return <Kiosk />;
}
